export enum orderRequestStatusTypes {
  pending = "pending",
  confirmed = "confirmed",
  picked = "picked",
  dispatched = "dispatched",
}

/** Stored on `orderRequests.status`. Set to confirmed when a hub order is linked. */
export const orderRequestStoredStatusDescriptions: Record<string, string> = {
  pending: "No hub order has been created from this request yet.",
  confirmed: "A hub order has been created and linked to this request.",
  picked:
    "Marked as picked. Rarely updated automatically — prefer the hub order / goods receipt status.",
  dispatched:
    "Marked as dispatched. Rarely updated automatically — prefer the hub order / goods receipt status.",
  cancelled: "This order request was cancelled.",
}

export function getOrderRequestStoredStatusDescription(status?: string | null): string {
  if (!status) {
    return "No status set."
  }
  return orderRequestStoredStatusDescriptions[status] ?? `Stored status: ${status}.`
}
